import React, { useEffect, useState } from "react";
import $ from 'jquery';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { images } from "./imagesToLoad";

import Header from './components/Header'
import Footer from './components/Footer'

import Home from './pages/Home'
import Trading from "./pages/Trading";
import Account from "./pages/Account";
import Fee from "./pages/Fee";
import Bonus from "./pages/Bonus";
import SupportAndFaq from "./pages/SupportAndFaq";
import AboutUs from "./pages/AboutUs";

function App() {
  const [ isLoading, setIsLoading ] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      }
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    isLoading && $('body').addClass("ovf-hidden");
    Promise
      .all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err)
        setIsLoading(false);
      });
    // eslint-disable-next-line  
  }, []);

  const [pass, setPass] = useState('');
  const [access, setAccess] = useState(false);

  const sendPass = () => {
    fetch('https://whoareyou.devindex.net/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pass }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.result === true && data.token) {
          const expirationTime = new Date().getTime() + 60 * 60 * 1000;
          localStorage.setItem('authToken', JSON.stringify({ token: data.token, expires: expirationTime }));
          setAccess(true);
        } else {
          alert('Неверный пароль');
        }
      });
  };

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem('authToken'));
    if (authData) {
      const currentTime = new Date().getTime();
      if (authData.expires > currentTime) {
        setAccess(true);
      } else {
        localStorage.removeItem('authToken');
      }
    }
  }, []);

  useEffect(() => {
    !isLoading && $('body').removeClass("ovf-hidden");
    !isLoading && $('#loader').addClass("hide");
  }, [isLoading]); 
  return (
    <>
        <Router>
          <Header/>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/trading" element={<Trading />} />
              <Route path="/accounts" element={<Account />} />
              <Route path="/fees" element={<Fee />} />
              <Route path="/bonus" element={<Bonus />} />
              <Route path="/support" element={<SupportAndFaq />} />
              <Route path="/about" element={<AboutUs />} />
            </Routes>
          <Footer/>
        </Router>
    </>
    
  );
}

export default App;